import React, {useMemo} from 'react';
import {useDropzone} from 'react-dropzone';

 const baseStyle =  {
  flex: 1,
  display: 'flex',
 
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const focusedStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

export function StyledDropzone(props:any) {
  const {
    getRootProps,
    getInputProps,
    acceptedFiles,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    accept: {
      'image/*': [], 
      'application/pdf': ['.pdf'], 
      'application/msword': ['.doc'], 
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
      'application/vnd.ms-powerpoint': ['.ppt'],
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
    },
    multiple: true,
    onDrop: (files: File[]) => {
      if (props.onFileDrop) {
        props.onFileDrop(files);
      }
    }
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isFocused,
    isDragAccept,
    isDragReject
  ]);

  // const files = acceptedFiles.map((file, index) => (
  //   <li key={index} style={{ fontSize: "14px", marginTop: "5px" }}>
  //     {file.name} - {(file.size / 1024).toFixed(2)} KB
  //   </li>
  // ));

  return (
    <div {...getRootProps({style})}>
      <input {...getInputProps()} name='files' />
      <p>Drag 'n' drop some files here, or click to select files</p>
      {/* {acceptedFiles.length > 0 && (
        <aside style={{ marginTop: "10px" }}>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {files}
          </ul>
        </aside>
      )} */}
    </div>
  );
}